import React from "react";
import Modal from "react-modal";
import "./ProceedToPaymentModal.css";
import LoadingPage from "./pages/LoadingPage";

const ProceedToPaymentModal = ({
  modalIsOpen,
  closeModal,
  onProceedToPaymentConfirm,
  isLoadingRedirect,
  reservedSlot,
  formatReservedSlotDate,
  formatReservationExpiryTime

}) => {
  const SLOT_RESERVE_TIMEOUT = process.env.REACT_APP_SLOT_RESERVE_TIMEOUT;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={true}
      contentLabel="Proceed To Payment"
      className="proceed_to_payment_modal"
      overlayClassName="Overlay"
    >
      <h3 className="proceed_to_payment_title">PROCEED TO PAYMENT</h3>
      {isLoadingRedirect ? (
        <LoadingPage height="70px" />
      ) : (
        <>
          <div className="modal_exit" onClick={closeModal}></div>
          {reservedSlot ? (
            <div className="reserved_slot_message_container">
              <span className="reserved_slot_message">
                Your slot reserved for{" "}
                <span className="highlighted_time">
                  {formatReservedSlotDate(reservedSlot.date)}
                </span>{" "}
                will expire at{" "}
                <span className="highlighted_time">
                  {formatReservationExpiryTime(reservedSlot.expiresAt)}
                </span>
                . If you do not complete payment for your order before this
                time, your slot will be released.
              </span>
            </div>
          ) : (
            <span className="slot_reserve_time_warn">
              After confirming, your slot will be reserved for{" "}
              <span className="highlighted_time">{SLOT_RESERVE_TIMEOUT} minutes</span>. If you do
              not complete payment for your order within this time, your slot
              will be released.
            </span>
          )}
          <button
            type="button"
            className="proceed_to_payment_btn"
            onClick={() => {
              onProceedToPaymentConfirm();
            }}
          >
            CONFIRM
          </button>
        </>
      )}
    </Modal>
  );
};

export default ProceedToPaymentModal;
